

import { AsnMap } from "@/models/api/asn/map";
import { ProcessAsnResponse } from "@/models/api/asn/process";
import AsnModule from "@/store/modules/asn";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

const asnModule = getModule(AsnModule);

import _ from "lodash";
import OrderPreviewModal from "@/components/widgets/Modals/OrderPreviewModal.vue";
import { debug } from "logrocket";


interface DeliveryForOption {
  label: string;
  value: number;
}

@Component
export default class ConfirmProcessModal extends Vue {

    @Prop()
    UploadId: string;

    @Prop()
    Map: AsnMap;

    @Prop()
    DeliveryFor: number;

    @Prop()
    DeliveryFors: DeliveryForOption[];
    
    Preview: ProcessAsnResponse = null;

    IsAgent: boolean = false;
    
    HasCustomerReferenceNumber: boolean = false;
    HasFacilityCode: boolean = false;
    HasBillToCompanyId: boolean = false;
    HasAgentBillToCompanyId: boolean = false;
    HasManufacturerCode: boolean = false;
    HasAgentManufacturerCode: boolean = false;
    HasOrderByCompany: boolean = false;
    HasAgentOrderByCompanyId: boolean = false;

    IsLoading: boolean = false;

    getDeliveryForName(deliveryForId){
        for(let i = 0; i < this.DeliveryFors.length; i++){
            if (this.DeliveryFors[i].value == deliveryForId){
                return this.DeliveryFors[i].label;
            }
        }

        return deliveryForId;
    }

    async created(){
        this.IsLoading = true;
        this.IsAgent = this.DeliveryFor !== null;
        this.Preview = await asnModule.previewAsn({ uploadId: this.UploadId, mapId: this.Map.id, deliveryFor: this.DeliveryFor });
        
        if (this.Preview !== null && this.Preview.orders !== null){
            this.HasCustomerReferenceNumber = this.Preview.orders[0].customerReferenceNumber !== null;
            this.HasBillToCompanyId = this.Preview.orders[0].billToCompanyId !== null;
            this.HasAgentBillToCompanyId = this.Preview.orders[0].agentBillToCompanyId !== null;
            this.HasManufacturerCode = this.Preview.orders[0].manufacturerCode !== null;
            this.HasAgentManufacturerCode = this.Preview.orders[0].agentManufacturerCode !== null;
            this.HasOrderByCompany = this.Preview.orders[0].orderByCompanyId !== null;
            this.HasAgentOrderByCompanyId = this.Preview.orders[0].orderByAgentCompanyId !== null;
            this.HasFacilityCode = this.Preview.orders[0].facilityCode !== null;
        }

        this.$emit('preview-validated', this.Preview);
        this.IsLoading = false;
    }
}
